import { Target } from "lucide-react";
import { ClubCrest } from "@/components/fsl/ClubCrest";

export function ScorersTable({ competition, rows, matchesOfficial, onOpen, testId }) {
  return (
    <div className="fsl-card overflow-hidden" data-testid={testId || `scorers-table-${competition.code || competition.id}`}>
      <div className="h-12 px-4 flex items-center justify-between border-b border-white/10 bg-ink-950/40">
        <span className="font-display font-bold uppercase">{competition.name}</span>
        <span className="text-[10px] uppercase tracking-wider text-fsl-gold inline-flex items-center gap-1"><Target className="h-3 w-3" /> {rows.length} marcatori · {matchesOfficial ?? 0} gare ufficiali</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-dark">
          <thead><tr><th className="w-10">Pos</th><th>Giocatore</th><th className="hidden sm:table-cell">Squadra</th><th className="text-right hidden md:table-cell">Presenze</th><th className="text-right hidden md:table-cell">Media</th><th className="text-right">Gol</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={6} className="text-center text-sm text-fsl-slate py-8">Nessun gol nelle gare ufficiali: la classifica si popola con i marcatori inseriti nei referti o nel Risultato diretto.</td></tr>}
            {rows.map((r) => (
              <tr key={r.player_id} className={r.pos === 1 ? "bg-fsl-gold/5" : ""} data-testid={`scorer-row-${r.player_id}`}>
                <td className="num font-display font-extrabold text-lg text-fsl-gold">{r.pos}</td>
                <td>
                  <button type="button" className="flex items-center gap-2 text-left hover:text-fsl-gold" onClick={() => onOpen?.(r)} disabled={!onOpen} data-testid={`scorer-open-${r.player_id}`}>
                    <span className="num text-xs text-fsl-slate w-6 shrink-0">{r.shirt_number ?? "–"}</span>
                    <span className="font-semibold">{r.name}</span>
                    {r.role && <span className="hidden lg:inline text-[10px] uppercase text-fsl-slate">{r.role}</span>}
                  </button>
                </td>
                <td className="hidden sm:table-cell"><span className="inline-flex items-center gap-2 text-sm">{r.club && <ClubCrest club={r.club} size={20} />}<span className="truncate max-w-[180px]">{r.club?.short_name || r.club?.name || r.team}</span></span></td>
                <td className="text-right num hidden md:table-cell text-fsl-slate">{r.played}</td>
                <td className="text-right num hidden md:table-cell text-fsl-slate">{r.played ? (r.goals / r.played).toFixed(2).replace(".", ",") : "–"}</td>
                <td className="text-right num font-display font-extrabold text-2xl">{r.goals}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
